import script from "./ReviewsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ReviewsCarousel.vue?vue&type=style&index=0&id=3d4bff88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4bff88"]])

export default __exports__